import { Component } from '@angular/core';
import { NavParams, NavController, ModalController } from 'ionic-angular';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';

import { AnaliseService } from '../../../../providers/analise-service';
import { MenuService } from '../../../../providers/menu-service';

@Component({
  selector: 'page-resumo-analise',
  templateUrl: 'resumo-analise.html',
  providers: [
    AnaliseService
  ]
})
export class ResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  loading: boolean = true;

  constructor(public navParams: NavParams,
    public navController: NavController,
    public alertService: AlertService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    private analiseService: AnaliseService, 
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
      super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();

    this.setModuloId(4);
  }

  carregarDados() {
    this.analiseService.obterListaAnalises(this.analiseService.codigoModuloContabilidade).subscribe(data => {
      this.listaAnalises = data;

      this.listaAnalises.forEach(x => {
        if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
        }
      });

      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  redirecionarParaAnalise(analise) {
    this.menuService.redirecionarSubPagina(this.analiseService.obterIdPaginaContabilidade(), analise);
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/modulo-analise/resumo-analise/resumo-analise.ts